module.exports = __webpack_public_path__ + "img/logo.2cae4fc0.png";